import { RevenueAndBilledHours } from "../components/RevenueAndBilledHours";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Revenue and Billed Hours",
  charts: [],
  filters: [],
  Component: RevenueAndBilledHours,
};